<form [formGroup]="form" appFormErrorScroll class="transparent">
  <div class="row">
    <div class="col-12 col-md-4">
      <mat-form-field>
        <mat-label>Loan Type</mat-label>
        <mat-select formControlName="type" placeholder="Select">
          @for (loanType of loanTypes | ekeyvalue; track loanType) {
            <mat-option [value]="+loanType.key">
              {{ loanType.value | translate }}
            </mat-option>
          }
        </mat-select>
        @if (form.get('type').invalid) {
          <mat-error>
            <app-validation-error [errors]="form.get('type').errors"></app-validation-error>
          </mat-error>
        }
      </mat-form-field>
    </div>

    @if (!form.initialValue.amount) {
      <div class="col-6 col-lg-4">
        <app-currency-input min="0"
          formControlName="amount"
          label="Original Loan Amount"
          placeholder="Original Loan Amount">
        </app-currency-input>
      </div>
    }

    @if (!form.initialValue.interestRate) {
      <div class="col-6 col-lg-4">
        <mat-form-field>
          <mat-label>Interest Rate</mat-label>
          <span matPrefix>%</span>
          <input matInput type="number" formControlName="interestRate" placeholder="Interest Rate" [min]="0" [max]="100"/>
          @if (form.get('interestRate').invalid) {
            <mat-error>
              <app-validation-error [errors]="form.get('interestRate').errors"></app-validation-error>
            </mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (!form.initialValue.availableRedraw) {
      <div class="col-6 col-lg-4">
        <app-currency-input min="0"
          formControlName="availableRedraw"
          label="Available Redraw"
          placeholder="Available Redraw">
        </app-currency-input>
      </div>
    }

    @if (!form.initialValue.repaymentFrequency) {
      <div class="col-6 col-lg-4">
        <mat-form-field>
          <mat-label>Repayment Frequency</mat-label>
          <mat-select formControlName="repaymentFrequency" placeholder="Select">
            @for (frequency of loanRepaymentFrequencies | ekeyvalue; track frequency) {
              <mat-option [value]="+frequency.key">
                {{ frequency.value | translate }}
              </mat-option>
            }
          </mat-select>
          @if (form.get('repaymentFrequency').invalid) {
            <mat-error>
              <app-validation-error [errors]="form.get('repaymentFrequency').errors"></app-validation-error>
            </mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (!form.initialValue.commencementDate) {
      <div class="col-6 col-lg-4">
        <app-datepicker formControlName="commencementDate" label="Commencement Date"></app-datepicker>
      </div>
    }

    @if (!form.initialValue.repaymentType) {
      <div class="col-6 col-lg-4">
        <mat-form-field>
          <mat-label>Repayment Type</mat-label>
          <mat-select formControlName="repaymentType" placeholder="Select">
            @for (repaymentType of loanRepaymentTypes | ekeyvalue; track repaymentType) {
              <mat-option [value]="+repaymentType.key">
                {{ repaymentType.value | translate }}
              </mat-option>
            }
          </mat-select>
          @if (form.get('repaymentType').invalid) {
            <mat-error>
              <app-validation-error [errors]="form.get('repaymentType').errors"></app-validation-error>
            </mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (!form.initialValue.interestType) {
      <div class="col-6 col-lg-4">
        <mat-form-field>
          <mat-label>Interest Type</mat-label>
          <mat-select formControlName="interestType" placeholder="Select">
            @for (interestType of loanInterestTypes | ekeyvalue; track interestType) {
              <mat-option [value]="+interestType.key">
                {{ interestType.value | translate }}
              </mat-option>
            }
          </mat-select>
          @if (form.get('interestType').invalid) {
            <mat-error>
              <app-validation-error [errors]="form.get('interestType').errors"></app-validation-error>
            </mat-error>
          }
        </mat-form-field>
      </div>
    }

  </div>
</form>
